import { render, staticRenderFns } from "./jiankangshebei.vue?vue&type=template&id=ac62cac4&scoped=true&"
import script from "./jiankangshebei.vue?vue&type=script&lang=ts&"
export * from "./jiankangshebei.vue?vue&type=script&lang=ts&"
import style0 from "./jiankangshebei.vue?vue&type=style&index=0&id=ac62cac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac62cac4",
  null
  
)

export default component.exports